import React from "react";

export default function GroupPeopleModal({
  group,
  title,
  count,
  countLabel,
  closeLabel,
  onClose,
  children,
}) {
  if (!group) return null;

  return (
    <div
      className="groups-members-modal-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="groups-members-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="groups-members-modal-title"
      >
        <button
          type="button"
          className="groups-detail-close"
          onClick={onClose}
          aria-label={closeLabel}
        >
          &times;
        </button>

        <div className="groups-members-modal-header">
          <div>
            <h3 id="groups-members-modal-title">{title}</h3>
            <p>{group.name}</p>
          </div>
          <span className="groups-members-count">
            {count} {countLabel}
          </span>
        </div>

        <div className="groups-members-list groups-members-list-modal">
          {children}
        </div>
      </div>
    </div>
  );
}
